import React from 'react'
import { InfoIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription } from '@/shared/components/ui/alert'
import { OptimizationStatus } from '@/shared/generated'
import { useOptimizationStatus } from '@/shared/hooks/data'
import { useOptimizationGroupId } from '@/shared/hooks/useOptimzationGroupId'

export function LockedForChangesNotification({
	className,
}: {
	className?: string
}) {
	const { t } = useTranslation()

	const optimizationGroupId = useOptimizationGroupId()!
	const status = useOptimizationStatus(optimizationGroupId)
	const isReady =
		status &&
		![
			OptimizationStatus.Updating,
			OptimizationStatus.Scheduled,
			OptimizationStatus.Locked,
		].includes(status)

	return isReady === false ? (
		<Alert className={className} variant='neutral'>
			<InfoIcon />
			<AlertDescription>
				{t(`app.optimization.update_is_forbidden.${status}`)}
			</AlertDescription>
		</Alert>
	) : null
}
